import * as Yup from 'yup'
import { detectCardBrand, luhnCheck } from '../api/utils/cardUtils';

export const BillingFormValidation = Yup.object().shape({
    firstName: Yup.string().trim().required('*First Name is required'),
    lastName: Yup.string().trim().required('* Last Name is required'),
    // cardNumber: Yup.string()
    //  .matches(/^\d{12,16}$/, 'Card Number should be between 12 and 16 digits')
    // .required('* Card Number is required'),
    cardNumber: Yup.string()
    .required("*Card Number is required")
    .test("valid-card", "Invalid card number", function (value) {
      if (!value) return false;

      const cleaned = value.replace(/\D/g, ""); // remove spaces
      const brand = detectCardBrand(cleaned);
      if (!brand) return this.createError({ message: "Unknown card type" });

      if (!brand.validLengths.includes(cleaned.length)) {
        return this.createError({
          message: `Invalid ${brand.name.toUpperCase()} card length`
        });
      }

      if (!luhnCheck(cleaned)) {
        return this.createError({ message: "Invalid card number" });
      }

      return true;
    }),
    expirationMonth: Yup.string()
    .required('Month required')
    .matches(/^(0?[1-9]|1[0-2])$/, 'Invalid month')
    .test(
      'future-month',
      'Expiry Month cannot be in the past',
      function (value) {
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth() + 1
        const expirationYear = this.parent.expirationYear
        if (
          parseInt(expirationYear, 10) === currentYear &&
          parseInt(value, 10) < currentMonth
        ) {
          return false
        }
        return true
      }
    ),

    expirationYear: Yup.string()
    .trim()
    .min(4, 'Year should be 4 digits')
    .max(4, 'Year should be 4 digits')
    .required('Year required')
    .test('future-year', 'Expiry Year cannot be in the past', (value) => {
      const currentYear = new Date().getFullYear()
      return parseInt(value, 10) >= currentYear
    }),
    cvv: Yup.string()
  .required("CVV required")
  .matches(/^[0-9]+$/, "CVV must be numbers only")
  .test("cvv-length", "Invalid CVV length", function (value) {
    const { cardNumber } = this.parent;
    if (!value) return false;

    const raw = cardNumber?.replace(/\D/g, "");
    const brand = detectCardBrand(raw);

    if (!brand) return true; // unknown type → skip
    return value.length === brand.cvvLength;
  })
    // cvv: Yup.string()
    // .matches(/^\d{3,4}$/, 'CVV should be 3 or 4 digits')
    // .required('CVV required'),
})
